import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-confir-endtrial',
    templateUrl: './confir-endtrial.component.html',
    styleUrls: ['./confir-endtrial.component.scss']
})
export class ConfirEndtrialComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ConfirEndtrialComponent>,) {
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
